export default __webpack_public_path__ + "static/assets/32d7457380d06a3614f176a085318156.svg";